import { api } from 'api';

/**
 * add
 * @param {*} data
 * @returns
 */
export const setStayHandicaped = ({ stay_id, exemption_document }) => {
  return api.call('stays.set_exemption', {
    stay_id,
    exemption_document,
  });
};

/**
 * add
 * @param {*} data
 * @returns
 */
export const setTariff = ({ stay_id, tariff_id }) => {
  return api.call('stays.set_tariff', {
    stay_id,
    tariff_id,
  });
};
